import { Loader2 } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../common';
import { useDashboardContext } from './DashboardContext';
import { formatMoney, getOrderLabel, getStatusBadgeClass } from './helpers';

export const RecentOrdersCard: React.FC = () => {
  const { dashboard, selectedOutletId, loadingStates } = useDashboardContext();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.02)] lg:col-span-2 h-[300px] overflow-y-auto">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-[13px] font-semibold text-slate-900">
          Recent Bills &amp; Orders
        </h3>
        <Button
          className="text-[10px] font-semibold text-slate-500 hover:text-slate-900"
          onClick={() => navigate('/dashboard/reports/orders')}
          size="xs"
          variant="outline"
        >
          View All
        </Button>
      </div>
      <div className="flex-1 overflow-x-auto">
        {loadingStates.recent ? (
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="animate-spin text-slate-300" size={24} />
          </div>
        ) : (
          <table className="w-full border-collapse text-left text-[11px]">
            <thead>
              <tr className="border-b border-slate-100 text-slate-400">
                <th className="pb-2.5 font-medium">Bill</th>
                {!selectedOutletId && (
                  <th className="pb-2.5 font-medium">Outlet</th>
                )}
                <th className="pb-2.5 font-medium">Ref</th>
                <th className="pb-2.5 font-medium">Items</th>
                <th className="pb-2.5 text-right font-medium">Amount</th>
                <th className="pb-2.5 text-right font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {dashboard.recentOrders.slice(0, 5).map((order) => (
                <tr
                  key={order.order_id}
                  className="border-b border-slate-50 transition-colors last:border-0 hover:bg-slate-50/50"
                >
                  <td className="py-2.5 font-semibold text-slate-900">
                    #{order.bill_number}
                  </td>
                  {!selectedOutletId && (
                    <td className="py-2.5 text-slate-500">
                      {order.outlet_name}
                    </td>
                  )}
                  <td className="py-2.5">
                    <div className="font-semibold text-slate-900">
                      {getOrderLabel(order)}
                    </div>
                    <div className="text-[9px] text-slate-400">
                      {order.mode}
                    </div>
                  </td>
                  <td className="py-2.5 text-slate-500">{order.item_count}</td>
                  <td className="py-2.5 text-right font-semibold text-slate-900">
                    {formatMoney(order.net_amount)}
                  </td>
                  <td className="py-2.5 text-right">
                    <span
                      className={`rounded-md px-1.5 py-0.5 text-[9px] font-semibold ${getStatusBadgeClass(
                        order.status_name,
                      )}`}
                    >
                      {order.status_name}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
